export const environment = {
    production: false,
    apiUrl: 'https://colony-admin-qa.transnetyx.com/api',

    auth0: {
        domain: 'login-qa.transnetyx.com',
        clientId: 'buqhss81qKKVSpgffGqSStpkIP2fJYXF',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-qa.transnetyx.com/v2/logout/colony`,
        logoutUrl: 'https://login-qa.transnetyx.com/v2/logout',
    },

    accountsUrl: 'https://accounts-qa.transnetyx.com/',
    geneticMonitoring: 'https://quickorder-qa.transnetyx.com/MVC/GeneticMonitoring',
    microbiome: 'https://quickorder-qa.transnetyx.com/MVC/Microbiome',
    supportHubUrl: 'https://www-qa.transnetyx.com/support',
    quickorder: 'https://quickorder-qa.transnetyx.com/home',

    colonyNotificationsUrl: 'https://colony-qa.transnetyx.com/Notifications',
    colonyOrdersCartUrl: 'https://colony-qa.transnetyx.com/Orders/Cart',
    colonyUrlDashboard: 'https://colony-qa.transnetyx.com',
    colonyUrlStrains: 'https://colony-qa.transnetyx.com/Strains',
    colonyUrlGeneMutations: 'https://colony-qa.transnetyx.com/Mutations',
    colonyUrlMice: 'https://colony-qa.transnetyx.com/Mice/MiceList',
    colonyUrlBreedings: 'https://colony-qa.transnetyx.com/Breedings',
    colonyUrlLitters: 'https://colony-qa.transnetyx.com/Litters',
    colonyUrlCages: 'https://colony-qa.transnetyx.com/Cage',
    colonyUrlCagesMapView: 'https://colony-qa.transnetyx.com/Cage/Cages',
    colonyUrlCagesList: 'https://colony-qa.transnetyx.com/Cage/CageList',
    colonyUrlCagesWorkbench: 'https://colony-qa.transnetyx.com/Cage/Workbench',
    colonyUrlTasks: 'https://colony-qa.transnetyx.com/Tasks',
    colonyUrlAmi: 'https://colony-qa.transnetyx.com/Ami/Projects',
    colonyUrlAmiCalculator: 'https://colony-qa.transnetyx.com/AmiCalculator',
    colonyUrlAdministrationUsers: 'https://colony-qa.transnetyx.com/Admin/User',
    colonyUrlAdministrationGroups: 'https://colony-qa.transnetyx.com/Admin/Group',
    colonyUrlAdministrationAuditLog: 'https://colony-qa.transnetyx.com/Admin/AuditLogSearch',
    colonyUrlAdministrationMouseImport: 'https://colony-qa.transnetyx.com/Mice/ImportAdmin',
    colonyUrlAdministrationReloadGroupData: 'https://colony-qa.transnetyx.com/Admin/Group/ResetGroups',
    colonyUrlAdministrationBannerMaintenance: 'https://colony-qa.transnetyx.com/Admin/Banner/Details',
    colonyUrlAdministrationScheduledJobs: 'https://colonyhangfireqa.azurewebsites.net/hangfire',
};
